import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { getIn } from 'seamless-immutable';
import { formatPrice } from '@catalogo/core-helpers/price';

const Green = styled.span`
  color: ${({ theme }) => theme.success.medium};
`;

export const Price = ({ payment }) => {
  const price = formatPrice(getIn(payment, ['price']));
  const discountRate = getIn(payment, ['discount', 'rate']);

  return (
    <>
      <strong>R$ {price}</strong>
      {discountRate > 0 && <Green> ({discountRate}% de desconto)</Green>}
    </>
  );
};

Price.propTypes = {
  payment: PropTypes.shape({
    price: PropTypes.number,
    discount: PropTypes.shape({
      rate: PropTypes.number,
    }),
  }),
};
